import { useState } from 'react';

import { UiButton } from '@shared/common/ui';

function fmt(value) {
  return `${new Intl.NumberFormat('ru-RU').format(value ?? 0)} ₽`;
}

export function QrPaymentModal({ payment, onClose }) {
  const [copied, setCopied] = useState(false);
  const [codeCopied, setCodeCopied] = useState(false);

  const copyPaymentUrl = async () => {
    try {
      await navigator.clipboard.writeText(payment.paymentUrl);
    } catch {
      const input = document.createElement('textarea');
      input.value = payment.paymentUrl;
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }
    setCopied(true);
  };

  const copyCode = async () => {
    if (!payment.paymentCode) return;
    try {
      await navigator.clipboard.writeText(payment.paymentCode);
    } catch {
      const input = document.createElement('textarea');
      input.value = payment.paymentCode;
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }
    setCodeCopied(true);
  };

  return (
    <div
      className="modal-backdrop"
      role="presentation"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="modal-card" role="dialog" aria-modal="true" aria-labelledby="qr-payment-title" style={{ maxWidth: 480 }}>
        <div className="modal-card__header">
          <h2 id="qr-payment-title">Оплата по QR</h2>
          <button type="button" className="clients-page__icon-btn" aria-label="Закрыть" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-card__body" style={{ textAlign: 'center' }}>
          <p>Платёж на сумму <strong>{fmt(payment.amount)}</strong> создан в PayKeeper.</p>
          {payment.paymentCode ? (
            <div style={{ margin: '16px 0' }}>
              <p className="muted" style={{ marginBottom: 4 }}>
                Код для страницы оплаты на сайте
              </p>
              <p style={{ fontSize: 32, letterSpacing: 6, fontWeight: 700, margin: '8px 0' }}>
                {payment.paymentCode}
              </p>
              <UiButton type="button" variant="ghost" onClick={copyCode}>
                {codeCopied ? 'Код скопирован' : 'Скопировать код'}
              </UiButton>
            </div>
          ) : null}
          {payment.qrCode ? (
            <img
              src={payment.qrCode}
              alt="QR-код для оплаты"
              style={{ display: 'block', width: 280, maxWidth: '100%', margin: '16px auto' }}
            />
          ) : null}
          <div className="copy-field" style={{ textAlign: 'left' }}>
            <input className="copy-field__input" type="text" value={payment.paymentUrl} readOnly />
            <UiButton type="button" variant="ghost" onClick={copyPaymentUrl}>
              {copied ? 'Скопировано' : 'Копировать ссылку'}
            </UiButton>
          </div>
          <div className="modal-card__actions">
            <UiButton type="button" onClick={() => window.open(payment.paymentUrl, '_blank', 'noopener,noreferrer')}>
              Открыть оплату
            </UiButton>
            <UiButton type="button" variant="ghost" onClick={onClose}>
              Закрыть
            </UiButton>
          </div>
        </div>
      </div>
    </div>
  );
}
